import { render, staticRenderFns } from "./connection-ponty.vue?vue&type=template&id=8eb48fc6&scoped=true&"
import script from "./connection-ponty.ts?vue&type=script&lang=ts&"
export * from "./connection-ponty.ts?vue&type=script&lang=ts&"
import style0 from "./connection-ponty.vue?vue&type=style&index=0&id=8eb48fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb48fc6",
  null
  
)

export default component.exports